import { useState, Fragment } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  TextField,
  Typography
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { validateEmptyField } from '../../common/validations'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { sendProviderWarning } from '../../api/providers.service'
import { DialogTitle } from '../../components/DialogTitle'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const WarningForm = (props) => {
  const handleClose = props.onClose
  const classes = useStyles()
  const providerSelected = useSelector((state) => state.provider)
  const formTitle = 'Contactar con Conway'

  const [loading, setLoading] = useState(false)
  const [contactText, setContactText] = useState('')
  const [contactTextError, setContactTextError] = useState('')

  const validateForm = () => {
    const error = validateEmptyField(contactText) ?? ''
    setContactTextError(error)
    return error === ''
  }

  const handleInputChange = (event) => {
    setContactTextError('')
    setContactText(event.target.value)
  }

  const handleSetWarning = () => {
    if (!validateForm()) return
    setLoading(true)
    sendProviderWarning({
      providerId: providerSelected.id,
      warning: contactText
    })
      .then(() => {
        handleClose()
        setContactText('')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const Title = (_) => (
    <Fragment>
      <h2>{formTitle}</h2>
      <Typography color="primary" variant="body2">
        Informa a Conway de tus cierres temporales (vacaciones, traslados, etc.)
      </Typography>
    </Fragment>
  )

  return (
    <div>
      <Grid container spacing={2}>
        <DialogTitle title={<Title />} />
        <Grid item xs={12}>
          <TextField
            required
            label="Mensaje"
            multiline
            fullWidth
            variant="outlined"
            rows={4}
            value={contactText}
            helperText={contactTextError}
            error={contactTextError !== ''}
            onChange={handleInputChange}
          />
        </Grid>
        <SaveOrCancelButtons
          onSave={handleSetWarning}
          onCancel={handleClose}
          loading={loading}
          saveLabel="Enviar"
        />
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default WarningForm
